/**
* main，程序入口
*
*  * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
* @link
* @create 2018-03-15
*/




import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import http from './common/js/http'
import webapi from './common/js/api'
import conf from './config/base'
import axios from 'axios' 
import filters from './common/js/filter.js'

import {
clog,formatDateTime2,formatDateTime3,thousandBitSeparator,getUrlKey,getToken
} from './common/js/common.js'


import { routerNames } from "@/common/js/const.js";



Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))


import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import dateFormat from 'vux/src/tools/date/format.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import querystring from 'vux/src/tools/querystring/index.js'

Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)


Vue.use(DatetimePlugin)
Vue.use(ConfirmPlugin)

Vue.config.productionTip = conf.debug;
Vue.config.debug = conf.debug;
Vue.config.devtools = conf.debug; 
Vue.config.warnExpressionErrors = conf.debug
Vue.prototype.$ajax=axios 







/**
* 那么之后任何组件中都可以通过 this.$wechat 访问到 wx 对象。
考虑到你需要在引入插件后调用wx.config方法进行配置，你可以通过 Vue.wechat 在组件外部访问wx对象。
jssdk需要请求签名配置，你可以直接使用下面的ajaxPlugin。
*/


Vue.use(http)

Vue.use(webapi)


var FastClick = require('fastclick')
FastClick.attach(document.body)


regGlobalMethod();

/* eslint-disable no-new */
new Vue({
el: '#app',
store,
router,
template: '<App/>',
components: {
App
}
});


/**
* 注册全局的方法
*
* 在视图中 可以 用  this.$clog('xxxx')
*/
function regGlobalMethod() {

Vue.prototype.$routerNames = routerNames;

Vue.prototype.$querystring = querystring;

Vue.prototype.$dateFormat = dateFormat;

Vue.prototype.$clog = clog;


Vue.prototype.$formatDateTime2 = formatDateTime2;


Vue.prototype.$formatDateTime3 = formatDateTime3;

Vue.prototype.$thousandBitSeparator = thousandBitSeparator;

Vue.prototype.$cerr = function ($msg) {
var str = clog($msg, 'ERR');
return str;
}
}



// WEBPACK FOOTER //
// ./src/main.js